import { SET_PREVIOUS_LOCATION } from "reduxStore/actionTypes";

export const setPreviousLocation = (data: any) => ({
	type: SET_PREVIOUS_LOCATION,
	payload: data,
});
